import React from "react";
import { motion } from "framer-motion";
import { Icon } from "@iconify/react";
import { ReactComponent as TeamImg } from "../assets/komet-assets/TeamAsset.svg";
const teamMembers = [
    { name: "Ali Alfouly", role: "CEO, Founder", email: "A.alfouly@kometinstitut.com" },
    { name: "Sura Iftekhar", role: "COO", email: "s.iftekhar@kometinstitut.com" },
    { name: "Mohamed Eljakouby", role: "Head Of Instructors" },
    { name: "Hadir Ashraf", role: "Administration & Communication" },
    { name: "Sarab Khatab", role: "Administration & Communication" },
    { name: "Esraa Mahmoud", role: "Administration & Communication" },
    { name: "Nadine Salem", role: "Instructor" },
    { name: "Rowan Abdeldayem", role: "Instructor" },
    { name: "Sarah Qassem", role: "Instructor" },
    { name: "Hanah Qassem", role: "Instructor" },
    { name: "Mohamed Abdullatif", role: "Instructor" },
    { name: "Morad Youssef", role: "Instructor" },
    { name: "Haidy Mounir", role: "Instructor" },
    { name: "Mohammed Elsayed", role: "Instructor" },
    { name: "Abdullah", role: "Instructor" },
];

const topMembers = teamMembers.slice(0, 2);
const otherMembers = teamMembers.slice(2);

const OurTeam = () => {
    return (
        <div className="relative negative-nav-margin py-[10rem] min-h-screen flex flex-col items-center px-6">
            {/* Background Floating Bubbles */}
            <div className="absolute inset-0 overflow-hidden -z-10">
                {[...Array(10)].map((_, i) => (
                    <motion.div
                        key={i}
                        className="absolute w-32 h-32 bg-gradient-to-br from-red-500 to-yellow-400 opacity-40 rounded-full blur-3xl"
                        initial={{ y: 0 }}
                        animate={{ y: [0, -30, 0] }}
                        transition={{ duration: 6 + i * 0.5, repeat: Infinity, ease: "easeInOut" }}
                        style={{
                            top: `${Math.random() * 80}%`,
                            left: `${Math.random() * 80}%`,
                        }}
                    />
                ))}
            </div>
            <div className="flex flex-col sm:flex-row gap-10 mb-10">
                {topMembers.map((member, index) => (
                    <motion.div
                        key={index}
                        className="bg-white p-8 rounded-xl shadow-lg flex flex-col items-center space-y-4 border border-gray-200 w-full sm:w-1/2"
                        whileHover={{ scale: 1.05 }}
                        transition={{
                            type: "spring",
                            stiffness: 200,
                            damping: 10,
                            duration: 0.5,
                            delay: index * 0.1,
                        }}
                        initial={{ opacity: 0, y: 50 }}
                        animate={{ opacity: 1, y: 0 }}
                    >
                        <motion.div
                            className="w-24 h-24 bg-gradient-to-br from-yellow-500 to-red-400 text-white flex items-center justify-center rounded-full text-3xl font-bold"
                            whileHover={{ scale: 1.1 }}
                        >
                            {member.name.charAt(0)}
                        </motion.div>
                        <h3 className="text-2xl font-semibold text-gray-800">{member.name}</h3>
                        <p className="text-gray-600 text-lg">{member.role}</p>
                        {member.email && (
                            <a
                                href={`mailto:${member.email}`}
                                className="text-yellow-500 hover:text-red-500 transition flex items-center gap-2 text-lg"
                            >
                                <Icon icon="mdi:email-outline" className="text-2xl" />
                                {member.email}
                            </a>
                        )}
                    </motion.div>
                ))}
            </div>

            <motion.h1
                className="text-5xl font-bold text-germanAccentText text-center mb-2"
                initial={{ opacity: 0, y: -50 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 1 }}
            >
                <TeamImg className="max-w-lg" />
            </motion.h1>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
                {otherMembers.map((member, index) => (
                    <motion.div
                        key={index}
                        className="bg-white p-6 rounded-xl shadow-lg flex flex-col items-center space-y-4 border border-gray-200"
                        whileHover={{ scale: 1.05 }}
                        transition={{
                            type: "spring",
                            stiffness: 200,
                            damping: 10,
                            duration: 0.5,
                            delay: index * 0.1,
                        }}
                        initial={{ opacity: 0, y: 50 }}
                        animate={{ opacity: 1, y: 0 }}
                    >
                        <motion.div
                            className="w-20 h-20 bg-gradient-to-br from-yellow-500 to-red-400 text-white flex items-center justify-center rounded-full text-2xl font-bold"
                            whileHover={{ scale: 1.1 }}
                        >
                            {member.name.charAt(0)}
                        </motion.div>
                        <h3 className="text-xl font-semibold text-gray-800">{member.name}</h3>
                        <p className="text-gray-600">{member.role}</p>
                        {member.email && (
                            <a
                                href={`mailto:${member.email}`}
                                className="text-yellow-500 hover:text-red-500 transition flex items-center gap-2"
                            >
                                <Icon icon="mdi:email-outline" className="text-xl" />
                                {member.email}
                            </a>
                        )}
                    </motion.div>
                ))}
            </div>
        </div>
    );
};

export default OurTeam;
